<script setup lang="ts">
import { VButton } from '@shared/component/VButton';
import VSizeContainer from '@shared/layout/VSizeContainer/VSizeContainer.vue';

defineProps<{ loading: boolean; disabled: boolean }>();

const emit = defineEmits<{ submit: [] }>();
</script>
<template>
  <div class="sticky bottom-0 z-10 border-t border-grey-200 bg-white">
    <VSizeContainer
      class="relative flex items-center justify-end p-4 after:absolute after:z-[-1] after:shadow-top after:2xl:-inset-x-10 after:2xl:inset-y-0"
    >
      <VButton :disabled :loading @click="emit('submit')" prepend-icon="far fa-paper-plane">
        Verzenden
      </VButton>
    </VSizeContainer>
  </div>
</template>
